import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import CheckboxField from "../../../components/Fields/CheckboxField";
import { FormConfig } from "../../../components/Fields/Types";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import SpinnerOverlay from "../../../components/Spinner/SpinnerOverlay";
import { useNotifications } from "../../../contexts/notificationContext";
import ItemRevisionModel from "../../../models/ItemRevisionModel";
import DataService from "../../../services/data.service";
import { Result } from "../../../types/Result";

interface DuplicateItemRevisionModel {
    itemId: number
    itemRevisionId: number
    addToProjects: boolean
}

interface ItemRevisionPopupProps {
    show: boolean
    onHide: (newItemRevisionId?: number) => void
    itemRevision: ItemRevisionModel
}

const DuplicateItemRevisionPopup: React.FC<ItemRevisionPopupProps> = ({ show, onHide, itemRevision }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const [showSpinner, setShowSpinner] = useState(false);
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<DuplicateItemRevisionModel>({
        itemId: itemRevision.itemId,
        itemRevisionId: itemRevision.id,
        addToProjects: false
    });

    function submit() {
        if (formData) {
            setShowSpinner(true)
            DataService
                .create<number>(`api/v1/ItemRevisions/Duplicate`, formData)
                .then(response => {
                    setShowSpinner(false)
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        onHide(response.data);
                    }
                })
                .catch(e => { setShowSpinner(false); handleException(e) });
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'addToProjects', label: 'Add the duplicate to the same projects', labelSize: 5 },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <>
            <Popup show={show} onHide={onHide} size={'lg'} title={'Duplicate item revision'} >
                <Popup.Body>
                    <CheckboxField {...getFieldProps('addToProjects')} />
                </Popup.Body>
                <Popup.Footer>
                    <SaveButton {...getSubmitButtonProps()} text='Duplicate' />
                </Popup.Footer>
            </Popup>
            { showSpinner && <SpinnerOverlay /> }
        </>
    );
}
export default DuplicateItemRevisionPopup;